<template>
  <transition
    :css="false"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <slot></slot>
  </transition>
</template>

<script setup>
  const props = defineProps({
    duration: { type: Number, default: 250 },
    disabled: { type: Boolean, default: false },
  });

  function beforeEnter(el) {
    if (props.disabled) return;
    el.style.height = "0";
    el.style.overflow = "hidden";
    el.style.transition = `height ${props.duration}ms ease-out`;
  }

  function enter(el, done) {
    if (props.disabled) {
      done();
      return;
    }
    el.offsetHeight; // force reflow
    el.style.height = el.scrollHeight + "px";
    setTimeout(done, props.duration);
  }

  function afterEnter(el) {
    if (props.disabled) return;
    el.style.height = "";
    el.style.overflow = "";
    el.style.transition = "";
  }

  function beforeLeave(el) {
    if (props.disabled) return;
    el.style.height = el.scrollHeight + "px";
    el.style.overflow = "hidden";
    el.style.transition = `height ${props.duration}ms ease-out`;
  }

  function leave(el, done) {
    if (props.disabled) {
      done();
      return;
    }
    el.offsetHeight; // force reflow
    el.style.height = "0";
    setTimeout(done, props.duration);
  }

  function afterLeave(el) {
    if (props.disabled) return;
    el.style.height = "";
    el.style.overflow = "";
    el.style.transition = "";
  }
</script>
